import "./tab-navigation-spacer.scss"

const TabNavigationSpacer = () => {
  return <div className="tab-nav-spacer"></div>
}

export default TabNavigationSpacer;